
import { defineComponent } from "vue";
import { store } from "@/store";

export default defineComponent({
  components: {},
  props: {
    stepId: {
      type: String
    },
  },
  emits: ["reload"],
  data() {
    return {
      submitted: false,
      loading: false,
      formName: "",
      name: "",
    };
  },
  computed: {
    step: function () {
      return store.getters["processModules/getMilestones"].find((s: any) => s.stepId === this.stepId)
    },
  },
  watch: {
    step: function () {
      this.formName = this.step?.name;
    }
  },
  mounted() {
    this.name = "";
  },
  methods: {
    submit: async function () {
      this.submitted = true;

      store.dispatch("processModules/deleteMilestone", { stepId: this.stepId, typeId: this.step.typeId });

      this.submitted = false;
      this.name = "";

      const el = this.$refs["closeBtn"] as any;
      el.click();

      this.$emit("reload");
    },
  },
});
